/**
 * List totals for Stock Management summary cards.
 * @param {Array<{ equity?: number|string|null }>} rows
 */
export function summarizeStockListRows(rows) {
  let totalInvestment = 0;
  const list = Array.isArray(rows) ? rows : [];
  for (const row of list) {
    const equity = Number(row?.equity);
    if (Number.isFinite(equity)) totalInvestment += equity;
  }
  return { stockCount: list.length, totalInvestment };
}
